import { useTranslate } from "@refinedev/core";
import { Flex, Typography } from "antd";
import { Badge } from "@libertify/ui";
import { useSession } from "hooks/useSession";
import { useLiveViewerCount } from "hooks/useLiveViewerCount";

export const LiveViewersBadge = () => {
  const t = useTranslate();
  const { currentOrganization } = useSession();
  const { total, isLoading, isError } = useLiveViewerCount(
    currentOrganization?.id
  );
  const isLive = total > 0;

  // Without the seed the total misses viewers who joined before the page loaded.
  if (isLoading || isError) return null;

  return (
    <Flex align="center" gap={6} aria-live="polite">
      <Badge dot status={isLive ? "success" : "default"} animated={isLive} />
      <Typography.Text>
        {t("media.analytics.liveViewers", { count: total })}
      </Typography.Text>
    </Flex>
  );
};
